import { Column } from './column';
import { MathFunction } from './mathfunction';
export class ValueField {
    column: Column;
    mathFn: MathFunction;
    mathFns: MathFunction[];
}
